import React, { ChangeEvent } from 'react'
import Image from 'next/image'
import { useAppIntl } from 'src/i18n'
import styles from './styles.module.scss'

type Item = {
  slug: string
  title: string
  mainImage: {
    data: {
      attributes: {
        url: string
        alternativeText: string
      }
    }
  }
}

type DataObject = Record<string, Item[]>

export const SearchBar: React.FC<{
  onFilter: (searchWord: string) => void
  userInput: string
  dataObject: DataObject
}> = ({ onFilter, userInput }) => {
  const intl = useAppIntl()

  const handleClearInput = () => {
    onFilter('')
  }

  return (
    <div className={styles.searchbar}>
      <h2 className={styles.searchbar__title}>
        {intl.t('toplist.searchBar.title')}
      </h2>
      <div className={styles.searchbar__container}>
        <Image
          className={styles.icon}
          src='/assets/icons/icon-search-grey.svg'
          width='24'
          height='24'
          alt='Search icon'
        />
        <input
          type='text'
          className={styles.searchbar__input}
          placeholder={intl.t('toplist.searchBar.placeholder')}
          value={userInput}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onFilter(event.target.value)
          }
        />
        <Image
          className={styles.closeIcon}
          src='/assets/icons/icon-close-green.svg'
          width='15'
          height='15'
          alt='scroll left'
          onClick={handleClearInput}
        />
      </div>
    </div>
  )
}
